import ApplicationSerializer from 'lumen/serializers/application';

export default class CostSettingCostSerializer extends ApplicationSerializer {}
